import { createSelector } from "@ngrx/store";
import * as fromRoot from '../../../_store';
import { DeputyStateModel } from "../actions/deputy.actions";
import * as fromFeature from '../reducers';
import * as fromDeputy from '../reducers/deputy.reducer';


export const getDeputyState = createSelector(
    fromFeature.core,
    (state: fromFeature.CoreState) => state ? state.deputy : null
);

export const getDeputyEntities = createSelector(
    getDeputyState,
    fromDeputy.getEntities
);

export const getSelectedDeputyStateModel = createSelector(
    getDeputyEntities,
    fromRoot.getRouterState,
    (entities, router): DeputyStateModel => {
        return router && router.state && entities && entities[fromDeputy.buildSelectId('global')];
    }
);

export const getSelectedPossibleDeputies = createSelector(
    getSelectedDeputyStateModel,
    fromRoot.getRouterState,
    (entity: DeputyStateModel): any => {
       return entity && entity.possibleDeputies
    }
);


export const getSelectedIsPhotosLoaded = createSelector(
    getSelectedDeputyStateModel,
    fromRoot.getRouterState,
    (entity: DeputyStateModel): any => {
       return entity && entity.isPhotosLoaded
    }
);


export const getSelectedCurrentSubstitute = createSelector(
    getSelectedDeputyStateModel,
    fromRoot.getRouterState,
    (entity: DeputyStateModel): any => {
       return entity && entity.currentSubstitute
    }
);

export const getSelectedUserPossibleImpersonalizations = createSelector(
    getSelectedDeputyStateModel,
    fromRoot.getRouterState,
    (entity: DeputyStateModel): any => {
      return entity && entity.possibleImpersonalizationList
    }
  );

  export const getSelectedPossibleImpersonalizationsBusinessEntityUsers = createSelector(
    getSelectedDeputyStateModel,
    fromRoot.getRouterState,
    (entity: DeputyStateModel): any => {
      return entity && entity.businessEntityUsers
    }
  );
export const getSelectedCurrentImpersonalization = createSelector(
    getSelectedDeputyStateModel,
    fromRoot.getRouterState,
    (entity: DeputyStateModel): any => entity && entity.currentImpersonalization
);